import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { useBasketCount } from './NciNavigation/hooks/useBasketCount';
import NciNavigation from './NciNavigation';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false
    }
  }
});

const Navigation = () => (
  <QueryClientProvider client={queryClient}>
    <RenderNavigation />
  </QueryClientProvider>
);

const RenderNavigation = () => {
  useBasketCount();
  return <>{window.isNciNavigationOnly && <NciNavigation />}</>;
};

export default Navigation;
